import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVipCrownQueen2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M3.594,17.25A2.27,2.27,0,0,0,4,21.75H20a2.192,2.192,0,0,0,1.679-.723,2.3,2.3,0,0,0,.56-1.527,2.169,2.169,0,0,0-1.828-2.25Z" }), /* @__PURE__ */ _jsx("path", { d: "M20.2,16.25a.5.5,0,0,0,.491-.4l1.2-6.11a2.257,2.257,0,1,0-1.61-.548l-2.425,2.767a.5.5,0,0,1-.744.009L13.053,7.539a2.75,2.75,0,1,0-2.106,0L6.9,11.954a.5.5,0,0,1-.377.162.5.5,0,0,1-.371-.174L3.758,9.158a2.245,2.245,0,1,0-1.58.585l1.151,6.1a.5.5,0,0,0,.491.407Z" })]
});
export default SvgVipCrownQueen2;
